export default __webpack_public_path__ + "static/media/gard.03925f76.jpg";